export const MOVE_ITEM = 'MOVE_ITEM';

export const moveItem = ({ context, itemId, direction }) => ({
  type: MOVE_ITEM,
  context,
  itemId,
  direction,
});
